module.exports = __webpack_public_path__ + "static/media/IMG_2667.3ca7b4c4.JPG";